// ======================================================================
// File Name       : GroupRegisterEdit
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Form, Row } from 'react-bootstrap';
import FormControlValidate from '../FormControlValidate';

class GroupRegisterEdit extends Component {
  constructor() {
    super();
    this.validation = this.validation.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
  }

  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  onInputChange({ target }) {
    const { name, value } = target;
    this.props.handleInputChange(name, value);
  }

  render() {
    const { editingGroup } = this.props;
    const { groupName, groupSecernId } = editingGroup;
    this.refsToValidate = [];
    return (
      <div>
        <Form className='form-horizontal'>
          {groupSecernId && (
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                ユーザーグループID
              </Col>
              <Col className='padding-top-10' sm={9}>
                {groupSecernId}
              </Col>
            </Form.Group>
          )}
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              ユーザーグループ名<span className="required">&nbsp;(※)</span>
            </Col>
            <Col sm={9} className='padding-right-15'>
              <FormControlValidate
                name="groupName"
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
                required
                maxLength="256"
                value={groupName}
                onChange={this.onInputChange}
                label="ユーザーグループ名" />
            </Col>
          </Form.Group>
        </Form>
      </div>
    );
  }
}

GroupRegisterEdit.propTypes = {
  groupBySecernId: PropTypes.shape().isRequired,
  editingGroup: PropTypes.shape().isRequired,
  handleInputChange: PropTypes.func.isRequired,
};

export default GroupRegisterEdit;
